module.exports = __webpack_public_path__ + "media/bootstrap-icons/box-arrow-right-186f661e.svg";